<template>
  <img
    v-if="chosenAvatarImage"
    :src="chosenAvatarImage"
    :alt="headerTitle"
    class="avatar"
  >
  <div
    v-else
    class="avatar"
  >
    <div class="avatar-initial-outer">
      <div class="avatar-initial-inner">
        {{ nameInitials }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['avatarImage', 'animatedAvatarImage', 'headerTitle', 'isShowingOpenChat']),
    nameInitials (): string {
      if (!this.headerTitle) return ''

      return this.headerTitle
        .split(' ')
        .slice(0, 2)
        .map(word => word[0].toUpperCase())
        .join('')
    },
    chosenAvatarImage (): string {
      if (this.isShowingOpenChat) {
        return this.animatedAvatarImage
      } else {
        return this.avatarImage
      }
    }
  }
}
</script>

<style src="./customer-avatar.scss" />
